import { Button, Col, Input, Modal, Row, Select, Spin, Table } from 'antd';
import Title from 'antd/es/typography/Title';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getAlignObjectiveKr } from 'app/entities/common/common.reducer';
import { setFilterRowSelectionObjKr } from 'app/entities/filters/filters.reducer';
import { getEntities as getPlanPeriods } from 'app/entities/plan-period/plan-period.reducer';
import TableComponent from 'app/shared/component/table/table';
import { OrderByType } from 'app/shared/model/enum/order-type.enum';
import { PlantPeriodType } from 'app/shared/model/enum/plantPeriod.enum';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DESC, ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { filterOption } from 'app/shared/util/select-filter';
import * as _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { getPaginationState } from 'react-jhipster';
import { useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';
import { columns, versionPlanPeriodYear } from './config';

const { Search } = Input;

type IRepresentatives = {
  isOpen: boolean;
  defaultSelected: any[];
  onClose: (isUpdate: boolean, itemSelected?: any[]) => void;
};

export const ObjectiveKRRowSelection = ({ isOpen, onClose, defaultSelected }: IRepresentatives) => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'lastModifiedDate', DESC), pageLocation.search),
  );

  const filterAObjective = useAppSelector(state => state.filters.objective);
  const filters = useAppSelector(state => state.filters.rowSelectionObjKr);
  const planPeriodList = useAppSelector(state => state.planPeriod.entities);
  const alignObjKrList = useAppSelector(state => state.common.alignObjKr);
  const isLoading = useAppSelector(state => state.common.loadingAlign);

  const [selectedItem, setSelectedItem] = useState<any[]>();
  const [selectedRowKey, setSelectedRowKeys] = useState<any[]>(['a7d42571-0d61-a9a1-40f6-3a132eccaa56']);

  useEffect(() => {
    dispatch(getPlanPeriods({}));
  }, [])

  useEffect(() => {
    getAllEntities();
  }, [paginationState.activePage, paginationState.itemsPerPage, paginationState.sort, filters]);

  const getAllEntities = () => {
    dispatch(
      getAlignObjectiveKr({
        searchText: filters?.searchText,
        page: filters?.searchText ? paginationState.activePage : 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        planPeriodId: filters?.planPeriodId ?? filterAObjective?.planPeriodId,
        partyId: filterAObjective?.accountableId,
        okrVersion: filters?.okrVersion
      }),
    );
  };

  const handleChange = (pageNumber: number, size: number, sorter: any) => {
    const { order, sort } = paginationState;
    setPaginationState({
      ...paginationState,
      order: Object.keys(sorter).length !== 0 ? (sorter.order && OrderByType[sorter.order] === OrderByType.descend ? DESC : ASC) : order,
      sort: Object.keys(sorter).length !== 0 ? sorter.columnKey : sort,
      activePage: pageNumber,
      itemsPerPage: size,
    });
  };

  const handleFreeTextSearchQuery = query => {
    dispatch(
      setFilterRowSelectionObjKr({
        ...filters,
        searchText: query,
      }),
    );
  };

  const rowSelection = {
    selectedRowKey,
    onChange(selectedRowKeys: React.Key[], selectedRows: any[]) {
      setSelectedRowKeys(selectedRowKeys)
      setSelectedItem(selectedRows)
    },
  };

  const handleClose = () => {
    onClose(false);
  };

  const handleConfirm = () => {
    onClose(true, selectedItem);
  };

  const handleChangePlanPeriod = (value: string) => {
    const detailPlanPeriod = _.find(planPeriodList, o => o.id === value);
    if (detailPlanPeriod) {
      dispatch(
        setFilterRowSelectionObjKr({
          ...filters,
          reportScheduleId: null,
          planPeriodId: value,
          planPeriodType: detailPlanPeriod.planPeriodType,
        }),
      );
    }
  };

  const handleChangeAdjustPlanPeriods = value => {
    dispatch(
      setFilterRowSelectionObjKr({
        ...filters,
        okrVersion: value,
      }),
    );
  };

  return (
    <Spin spinning={isLoading} delay={300}>
      <Modal
        open={isOpen}
        maskClosable={false}
        onCancel={() => {
          handleClose();
        }}
        footer={<Row className="d-flex action mt-3" justify="end">
          <Col>
            <Button size='large' className="primary" onClick={handleConfirm}>
              Chọn
            </Button>
          </Col>
          <Col>
            <Button
              className="secondary"
              onClick={() => {
                handleClose();
              }}
              size='large'
            >
              Hủy
            </Button>
          </Col>
        </Row>}
        width={1300}
      >
        <Container className="view">
          <Title level={3}>{`Chọn MT/KR cần liên kết với công việc ${filterAObjective?.accountableName ? `- ${filterAObjective?.accountableName}` : ''}`}</Title>
          <div className="table">
            <div className="header">
              <Col md={24}>
                <Row className='w-100'>
                  <Col md={4}>
                    <Select
                      className="w-100"
                      value={filters?.planPeriodId ?? filterAObjective?.planPeriodId}
                      showSearch
                      options={planPeriodList.map(x => {
                        return {
                          value: x.id,
                          label: x.name,
                        };
                      })}
                      onChange={handleChangePlanPeriod}
                      filterOption={filterOption}
                      placeholder="Chọn kỳ kế hoạch"
                      size="large"
                    />
                  </Col>
                  {filters?.planPeriodType === PlantPeriodType.Year && (
                    <>
                      <Col md={1} />
                      <Col md={5}>
                        <Select
                          className="w-100"
                          value={filters?.okrVersion}
                          options={versionPlanPeriodYear}
                          onChange={handleChangeAdjustPlanPeriods}
                          filterOption={filterOption}
                          placeholder="Chọn phiên bản"
                          size="large"
                        />
                      </Col>
                    </>
                  )}
                  <Col md={1} />
                  <Col md={11}>
                    <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                  </Col>
                </Row>
              </Col>
            </div>

            <Table
              rowSelection={rowSelection}
              dataSource={alignObjKrList.map(x => {
                return {
                  ...x,
                  key: x.id,
                  children: x.krSubSets.length > 0 && x.krSubSets.map(y => {
                    return {
                      key: y.id,
                      ...y
                    }
                  })
                }
              })}
              pagination={null}
              columns={columns}

            />
          </div>
        </Container>
      </Modal>
    </Spin>
  );
};

export default ObjectiveKRRowSelection;
